import './card-faq-cat.scss';

export default () => {
	// Accordion
	$( '.card-faq-cat__title' ).click( function ( e ) {
		e.preventDefault();

		let $this = $( this );

		if ( $this.next().hasClass( 'show' ) ) {
			$this.parent().removeClass( 'active' );
			$this.next().removeClass( 'show' );
			$this.next().slideUp( 350 );
		} else {
			$this.parent().parent().find( '.card-faq-cat' ).removeClass( 'active' );
			$this
				.parent()
				.parent()
				.find( '.card-faq-cat__content' )
				.removeClass( 'show' );
			$this.parent().parent().find( '.card-faq-cat__content' ).slideUp( 350 );
			$this.parent().addClass( 'active' );
			$this.next().toggleClass( 'show' );
			$this.next().slideToggle( 350 );
		}
	} );
};
